import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { debounce } from "base/utils";

import {
  Popover,
  POPOVER_POSITIONS
} from "@widgets/feedback/popover/index.jsx";
import { ColorPanel } from "@widgets/inputs/index.jsx";
import { PropertiesField } from "../field/index.jsx";

import styles from "./style.css";

export function ColorProperty({
  showReset,
  label,
  value,
  onChange,
  onReset,
  modified
}) {
  // eslint-disable-next-line kf/hook-func-name, react-hooks/exhaustive-deps
  const debouncedOnChange = debounce(onChange, 250);
  return (
    <PropertiesField
      label={label}
      onReset={onReset}
      showReset={showReset}
      modified={modified}
    >
      <Popover
        position={POPOVER_POSITIONS.RIGHT_TOP}
        arrowPointAtCenter={false}
        targetRenderer={() => {
          return (
            <div className={styles.colorinput}>
              <span className={styles.value}>{value}</span>
              <div
                className={styles.currentcolor}
                style={{
                  background: value
                }}
              />
            </div>
          );
        }}
      >
        <div className={styles.colorpanelcontainer}>
          <ColorPanel value={value} onChange={debouncedOnChange} />
        </div>
      </Popover>
    </PropertiesField>
  );
}

ColorProperty.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  onReset: PropTypes.func,
  modified: PropTypes.bool,
  showReset: PropTypes.bool
};
